import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import ReactPaginate from "react-paginate";
import "./CSS/Orders.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Customers = () => {
    const [customers, setCustomers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const customersPerPage = 5;

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        try {
            const response = await fetch(`${backend_url}/admin/get-all-users`);
            const data = await response.json();
            if (data.success && Array.isArray(data.users)) {
                setCustomers(data.users);
            } else {
                console.error("Failed to fetch customers:", data.message || data);
                setCustomers([]); // fallback to prevent undefined
            }
        } catch (error) {
            console.error("Error fetching customers:", error);
            setCustomers([]); // fallback to prevent undefined
        }
    };

    // Filter orders by search input
    const searchedUsers = customers.filter((user) =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.toLowerCase()) || 
        user.phoneNumber.toString().includes(searchQuery)
    );

    const offset = currentPage * customersPerPage;
    const currentUsers = searchedUsers.slice(offset, offset + customersPerPage);
    const pageCount = Math.ceil(searchedUsers.length / customersPerPage);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <div className="order-details-container">
          <div className="header-container">
            {/* Heading */}
            <h2 className="order-title">Customer Details</h2>

            {/* Search Bar */}
            <div className="search-bar">
                <span className="search-icon">🔍</span>
                <input
                    type="text"
                    placeholder="Search ..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            </div>
            {/* Table */}
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentUsers.length > 0 ? (
                            currentUsers.map((user) => (
                                <tr key={user.id || user._id}>
                                    <td>{user.name || "N/A"}</td>
                                    <td>{user.email || "N/A"}</td>
                                    <td>{user.phoneNumber || "N/A"}</td>
                                    <td>
                                        {`${user.address || "N/A"}, ${user.city || "N/A"}, ${user.pincode || "N/A"}, ${user.state || "N/A"}, ${user.country || "N/A"}`}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", padding: "16px" }}>
                                    No users found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


            {/* Pagination */}
            {currentUsers.length > customersPerPage && (
                <div className="pagination">
                    <ReactPaginate
                        previousLabel={"←"}
                        nextLabel={"→"}
                        breakLabel={"..."}
                        pageCount={pageCount}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                    />
                </div>
            )}
        </div>
    );
};

export default Customers;
